const FilterOption = ({ register, registerName, label, value }) => {
  return (
    <label className="mt-1 ui-checkbox text-sm font-normal">
      <input type="checkbox" value={value} {...register(registerName)} />
      <div className="ui-checkmark">
        <svg
          className="ui-icon w-2 h-2 text-white"
          focusable="false"
          aria-hidden="true"
          role="presentation"
        >
          <use href="#ui-icon-checkmark"></use>
        </svg>
      </div>
      <span>{label}</span>
    </label>
  );
};

export default FilterOption;
